import React, { Component } from "react";
import { withUnits } from "../../../../shared/containers/containerUnits";
import { states } from "../../../../reducers/queriesStates";
import CmsUnitSettings from "./CmsUnitSetings";

import styles from "./cmsUnitSettingGrops.module.scss";
import Preloader from "../../../../shared/items/static/preloader";

class CmsUnitSettingGrops extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
      updatingGroup: [],
    };
  }

  componentDidMount() {
    const { onGetUnitSettings, currentUnit } = this.props;

    if (currentUnit !== null) {
      onGetUnitSettings(currentUnit.id);
    }
  }

  componentDidUpdate(prevPeops) {
    const { onGetUnitSettings, currentUnit } = this.props;

    if (currentUnit !== null && currentUnit.id !== prevPeops.currentUnit.id) {
      onGetUnitSettings(currentUnit.id);
      this.setState({ updatingGroup: [] });
    }
  }

  setTabIndex(index) {
    this.setState({ tabIndex: index });
  }

  getTabs() {
    const { unitSettings } = this.props;
    const { tabIndex } = this.state;

    if (unitSettings.settingsGroups === undefined) {
      return null;
    }

    return (
      <div className={styles.cmsTabsContainer}>
        {unitSettings.settingsGroups.map((x, index) => {
          return (
            <div
              key={index}
              className={tabIndex === x.group ? styles.cmsTabActive : styles.cmsTab}
              style={{ display: "flex" }}
              onClick={this.setTabIndex.bind(this, x.group)}
            >
              <b>{x.title}</b>
            </div>
          );
        })}
      </div>
    );
  }

  getSettings() {
    const { unitSettings } = this.props;
    const { tabIndex } = this.state;

    if (unitSettings.settingsGroups === undefined || unitSettings.settingsGroups.length === 0) {
      return [];
    }

    return JSON.parse(JSON.stringify(unitSettings.settingsGroups.filter((x) => x.group === tabIndex)[0].settings));
  }

  onChangeSetting(value) {
    const { tabIndex, updatingGroup } = this.state;

    if (value) {
      if (
        !updatingGroup.some((x) => {
          return x === tabIndex;
        })
      ) {
        updatingGroup.push(tabIndex);
        this.setState({ updatingGroup: updatingGroup });
      }
    } else {
      this.setState({
        updatingGroup: updatingGroup.filter((x) => {
          return x !== tabIndex;
        }),
      });
    }
  }

  groupNeedUpdate() {
    const { tabIndex, updatingGroup } = this.state;

    return updatingGroup.some((x) => {
      return x === tabIndex;
    });
  }

  render() {
    const { unitSettingsDataState, currentUnit, height = 850, updateUnitSettingDataState } = this.props;

    if (unitSettingsDataState === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    const { tabIndex } = this.state;

    return (
      <div styles={{ height: height + "px" }}>
        {this.getTabs()}

        {updateUnitSettingDataState === states.REQUEST ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0px",
              paddingLeft: "20px",
              paddingTop: "5px",
              position: "absolute",
            }}
          >
            <Preloader />
          </div>
        ) : null}

        <CmsUnitSettings
          key={`${tabIndex}_${currentUnit.id}`}
          indexGroup={tabIndex}
          height={height - 200}
          onChangeSetting={this.onChangeSetting.bind(this)}
          needUpdate={this.groupNeedUpdate()}
        />
      </div>
    );
  }
}

export default withUnits(CmsUnitSettingGrops);
